function IconCrown({ size = 24, strokeWidth = 2.14286, color = '#1a1a1a' }: { size?: number; strokeWidth?: number; color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M15.4512 9.30469L15.9756 10.0918L16.8213 9.66895L21.8994 7.12891L19.7617 17.3936C19.5754 18.2876 18.7874 18.9286 17.874 18.9287H6.12598C5.21266 18.9286 4.42463 18.2876 4.23828 17.3936L2.09961 7.12891L7.17871 9.66895L8.02441 10.0918L8.54883 9.30469L12 4.12891L15.4512 9.30469Z"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}

IconCrown.displayName = 'IconCrown';

export default IconCrown;
